module.exports = __webpack_public_path__ + "static/media/fire-1.a709598d.svg";